import React from 'react';
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';

import { VscJson } from 'react-icons/vsc';
import NodeCardShell from '../Components/NodeCardShell';
import { getNodeSummary } from '../Components/nodeSummary';

const JSON_NODE_COLOR = '#A7ADA7';

const AssitantAI = ({ data, isConnectable, id, selected }) => {
  useSyncNodeInternals(id, `${data.saved}~${data.first}`);

  const jsonSummary = getNodeSummary({ type: 'json', data });

  return (
    <NodeCardShell
      icon={VscJson}
      color={JSON_NODE_COLOR}
      typeName="JSON"
      title={data.title || 'JSON'}
      summary={jsonSummary}
      trigger={data.user_response}
      selected={selected}
      handles={
        data.saved && (
          <Handle
            type="target"
            position={Position.Top}
            isConnectable={isConnectable}
            id={`target-${id}`}
            style={{ backgroundColor: JSON_NODE_COLOR }}
          />
        )
      }
    />
  );
};

export default React.memo(AssitantAI);
